'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _FlexCenter = require('../../../components/misc/FlexCenter');

var _FlexCenter2 = _interopRequireDefault(_FlexCenter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpdateCardSuccess = function UpdateCardSuccess(props) {
    return _react2.default.createElement(
        _FlexCenter2.default,
        { className: 'UpdateCardSuccess' },
        _react2.default.createElement(
            'h1',
            null,
            'Success'
        ),
        _react2.default.createElement(
            'p',
            null,
            'Your credit card details have been updated.'
        ),
        _react2.default.createElement(
            _reactRouter.Link,
            { className: 'Button FormButton primary', to: '/' },
            'OK'
        )
    );
};

exports.default = UpdateCardSuccess;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/updateCard/UpdateCardSuccess.js
// module id = 2107
// module chunks = 0